// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/minus.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'minus',
  version: 'outline',
  paths: [
    {
      d: 'M5 12h14',
    },
  ],
}
